export default __webpack_public_path__ + "./site.webmanifest";